import { siteConfig } from '@/app/config/global';
import { type VehicleCycledEnergyRecord } from '@/features/BatteryMonitoring/services/battery-monitoring-api/types/battery-monitoring-api';
import { type FilterKey } from '@/features/BatteryMonitoring/hooks/use-update-query-parameter-values';

export interface ChartSegment {
  color: string;
  getHeader: () => string;
  filterVehicle: ({ vehicle }: { vehicle: VehicleCycledEnergyRecord }) => boolean;
}

export interface SelectedChartSegment extends ChartSegment {
  segmentIndex: number;
}

interface ChartSegmentConfig {
  high: number;
  medium: number;
  indexKey: FilterKey;
}

export const stateOfHealthConfig: ChartSegmentConfig = {
  high: 0.9,
  medium: 0.85,
  indexKey: 'stateOfHealthIndex',
};

export const stateOfHealthSegments: ChartSegment[] = [
  {
    getHeader: () => `> ${stateOfHealthConfig.high * 100}%`,
    filterVehicle: ({ vehicle }) =>
      typeof vehicle.stateOfHealthRatio === 'number' && vehicle.stateOfHealthRatio >= stateOfHealthConfig.high,
    color: siteConfig.primaryColor,
  },
  {
    getHeader: () => `${stateOfHealthConfig.medium * 100}% to ${(stateOfHealthConfig.high - 0.01) * 100}%`,
    filterVehicle: ({ vehicle }) =>
      typeof vehicle.stateOfHealthRatio === 'number' &&
      vehicle.stateOfHealthRatio >= stateOfHealthConfig.medium &&
      vehicle.stateOfHealthRatio < stateOfHealthConfig.high,

    color: siteConfig.secondaryColor,
  },
  {
    getHeader: () => `< ${stateOfHealthConfig.medium * 100}%`,
    filterVehicle: ({ vehicle }) =>
      typeof vehicle.stateOfHealthRatio === 'number' && vehicle.stateOfHealthRatio < stateOfHealthConfig.medium,
    color: siteConfig.tertiaryColor,
  },
];

export const cycledEnergyPerKilometerConfig: ChartSegmentConfig = {
  high: 4.6,
  medium: 3,
  indexKey: 'cycledEnergyPerKilometerIndex',
};

export const cycledEnergyPerKilometerSegments: ChartSegment[] = [
  {
    getHeader: () => `${cycledEnergyPerKilometerConfig.high}+ kWh/km`,
    filterVehicle: ({ vehicle }) =>
      typeof vehicle.cycledEnergyPerKm === 'number' && vehicle.cycledEnergyPerKm >= cycledEnergyPerKilometerConfig.high,

    color: siteConfig.primaryColor,
  },
  {
    getHeader: () =>
      `${cycledEnergyPerKilometerConfig.medium + 0.1} to ${cycledEnergyPerKilometerConfig.high - 0.1} kWh/km`,
    filterVehicle: ({ vehicle }) =>
      typeof vehicle.cycledEnergyPerKm === 'number' &&
      vehicle.cycledEnergyPerKm >= cycledEnergyPerKilometerConfig.medium &&
      vehicle.cycledEnergyPerKm < cycledEnergyPerKilometerConfig.high,
    color: siteConfig.secondaryColor,
  },
  {
    getHeader: () => `0 - ${cycledEnergyPerKilometerConfig.medium.toFixed(1)} kWh/km`,
    filterVehicle: ({ vehicle }) =>
      typeof vehicle.cycledEnergyPerKm === 'number' &&
      vehicle.cycledEnergyPerKm < cycledEnergyPerKilometerConfig.medium,
    color: siteConfig.tertiaryColor,
  },
];
